import React from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Slider } from "@/components/ui/slider";
import { Switch } from "@/components/ui/switch";

export const Row = ({ label, children }) => (
  <div className="space-y-1"><Label className="text-[11px] uppercase tracking-wide text-muted-foreground">{label}</Label>{children}</div>
);

export const Num = ({ label, value, onChange, min = 0, max = 200, step = 1, unit = "", testid }) => (
  <Row label={<span className="flex justify-between w-full"><span>{label}</span><span className="normal-case">{value ?? 0}{unit}</span></span>}>
    <Slider min={min} max={max} step={step} value={[Number(value ?? 0)]} onValueChange={([v]) => onChange(v)} data-testid={testid} />
  </Row>
);

export const Color = ({ label, value, onChange, testid }) => (
  <Row label={label}>
    <div className="flex gap-2 items-center">
      <input type="color" value={/^#[0-9a-f]{6}$/i.test(value || "") ? value : "#ffffff"} onChange={(e) => onChange(e.target.value)} className="w-9 h-9 rounded border" data-testid={testid} />
      <Input value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder="няма" className="h-9 text-xs" />
    </div>
  </Row>
);

export const Text = ({ label, value, onChange, testid, ...rest }) => (
  <Row label={label}><Input value={value || ""} onChange={(e) => onChange(e.target.value)} className="h-9" data-testid={testid} {...rest} /></Row>
);

export const Pick = ({ label, value, onChange, options, testid }) => (
  <Row label={label}>
    <select value={value ?? ""} onChange={(e) => onChange(e.target.value)} className="w-full h-9 border rounded-md px-2 text-sm bg-white" data-testid={testid}>
      {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
    </select>
  </Row>
);

export const Flag = ({ label, value, onChange, testid }) => (
  <label className="flex items-center justify-between text-sm py-0.5"><span>{label}</span><Switch checked={!!value} onCheckedChange={onChange} data-testid={testid} /></label>
);

export const Group = ({ title, children }) => (
  <div className="border-t border-gold/15 pt-3 mt-3 space-y-3"><div className="text-xs font-semibold text-forest-deep">{title}</div>{children}</div>
);

export const PosXY = ({ label, value = "50% 50%", onChange, testid }) => {
  const [x, y] = value.split(" ").map((v) => parseInt(v, 10));
  return (
    <div className="grid grid-cols-2 gap-2">
      <Num label={`${label} X`} value={x} max={100} unit="%" onChange={(v) => onChange(`${v}% ${y}%`)} testid={`${testid}-x`} />
      <Num label={`${label} Y`} value={y} max={100} unit="%" onChange={(v) => onChange(`${x}% ${v}%`)} testid={`${testid}-y`} />
    </div>
  );
};
